import { makeStyles } from '@material-ui/core/styles'

const useStyles = makeStyles((theme) => ({
  banner: {
    marginTop: '16px',
    borderRadius: '0 0 5px 5px',
    overflow: 'hidden',
  },
  indicator: {
    width: '8px',
    height: '3px',
    background: '#EDF1F7',
    display: 'inline-block',
    borderRadius: '4px',
    margin: '0 4px',
    cursor: 'pointer',
    opacity: 0.3,
    [theme.breakpoints.down('sm')]: {
      width: '8px',
      height: '4px',
      margin: '0 2px',
    },
  },
  indicatorActive: {
    opacity: 1,
  },
}))

export default useStyles
